export const RECOVERY_CODES_GATE_COPY: {title: string; message: string} = {
    title: 'Save your recovery codes',
    message: 'Each code signs you in once if you lose access to your authenticator app or phone.',
};
